import React, { useEffect } from "react";
import "./Index.css";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import RelatoriosModuloProvider from "./RelatoriosModuloContext";
import PesquisarRelatoriosModulo from "./Events/PesquisarRelatoriosModulo";
import { LoadMask } from "../../../../Utils/mask";

const Index = () => {
  let match = useRouteMatch();
  useEffect(() => {
    LoadMask();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <RelatoriosModuloProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarRelatoriosModulo}
          />
        </Switch>
      </div>
    </RelatoriosModuloProvider>
  );
};

export default Index;
